import components from './components'
import mounted from './mounted'

export default {
  components,
  mounted
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/resources/index.js